import InformationalModal from "./InformationalModal";

const CustomerSentimentModal = () => {
  const text = () =>
    typeof window !== "undefined"
      ? `to the following page: ${window.location.href}`
      : "to a page...";

  return (
    <InformationalModal
      buttonText={"Information on data source"}
      variant="icon"
      title={"Our customer sentiment process"}
      body={`We're excited to provide you with a customer sentiment summary section on our Voltwise comparison tool installer pages! Please note that this information is compiled from online reviews and does not reflect the views of Voltwise. While we strive to provide accurate and up-to-date information, we cannot guarantee its completeness or accuracy. Therefore, please use this information as a starting point and always conduct your own research before making any decisions.`}
      secondaryButtonText={"Contact"}
      secondaryButtonLink={`mailto:hello@voltwise.co?subject=Voltwise Page Suggestion&body=Hi, I'd like to suggest an update ${text()}`}
    />
  );
};

export default CustomerSentimentModal;
